import React, { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { LoginForm, ProFormText } from "@ant-design/pro-form"
import { useUser } from "../../contexts/UserContext"
import { LockOutlined, UserOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"

import "./Login.css"

const Login = () => {
    const { t } = useTranslation()
    const { login } = useUser()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState("")

    const handleSubmit = async (values) => {
        const formData = new FormData()
        formData.append("Username", values.username)
        formData.append("Password", values.password)

        const result = await login(formData)

        if (result.success) {
            navigate("/dashboard", { replace: true })
        } else {
            setErrorMessage(result.message)
        }
    }

    const logoSrc = "AquaExpert2024_blue_lay.png"

    return (
        <div
            style={{
                maxWidth: "400px",
                margin: "0 auto",
                marginTop: "50px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <LoginForm
                className=".ant-pro-login-logo"
                logo={logoSrc}
                subTitle={t("page.login.title")}
                submitter={{
                    searchConfig: {
                        submitText: t("page.login.form.login")
                    }
                }}
                onFinish={handleSubmit}
            >
                <ProFormText
                    name="username"
                    fieldProps={{
                        size: "large",
                        prefix: <UserOutlined />
                    }}
                    placeholder={t("page.login.form.username")}
                    rules={[
                        {
                            required: true,
                            message: "Ange användarnamn"
                        }
                    ]}
                />
                <ProFormText.Password
                    name="password"
                    fieldProps={{
                        size: "large",
                        prefix: <LockOutlined />
                    }}
                    placeholder={t("page.login.form.password")}
                    rules={[
                        {
                            required: true,
                            message: "Ange lösenord"
                        }
                    ]}
                />
                {errorMessage && <div style={{ color: "red", marginBottom: "20px", marginLeft: "10px" }}>{errorMessage}</div>}
            </LoginForm>
            <div style={{ marginTop: "20px" }}>
                <Link to="/reset-password">{t("page.login.form.forgot-password")}?</Link>
            </div>
        </div>
    )
}

export default Login
